import type * as React from 'react';
import {MaterialReactTable} from 'material-react-table';
import {type CourseApproval} from '@/types/CourseApproval';
import {Alert, Stack} from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type Props = {
    selectedCourseApprovals : CourseApproval[];
};

const TableSelectedCourseApprovals = ({selectedCourseApprovals} : Props) : React.ReactElement => {
    const showError = selectedCourseApprovals.filter(courseApproval => courseApproval.request !== '').length > 0;

    const columns = [
        {
            accessorKey: 'compoundKey',
            header: 'ID',
            sort: true,
        },
        {
            accessorKey: 'schoolShortName',
            header: 'Building',
            sort: true,
        },
        {
            accessorKey: 'courseNumber',
            header: 'Course Code',
            sort: true,
        },
        {
            accessorKey: 'sectionNumber',
            header: 'Section Number',
            sort: true,
        },
    ];

    return <MaterialReactTable
        columns={columns}
        data={selectedCourseApprovals}
        initialState={{columnVisibility: {compoundKey: false}}}

        enableBottomToolbar={false}
        enableColumnActions={false}
        enableColumnFilters={false}
        enableDensityToggle={false}
        enableFilterMatchHighlighting={false}
        enableFullScreenToggle={false}
        enableGlobalFilter={false}
        enableHiding={false}
        enablePagination={false}

        muiTableBodyRowProps={({row}) => {
            return {
                sx: {
                    backgroundColor: row.original.request !== '' ? 'yellow' : '',
                    fontStyle: 'italic'
                }
            }
        }}

        renderTopToolbarCustomActions={() => <Stack
            sx={{
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <Stack
                sx={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    width: '100%',
                }}
            >
                <Box sx={{typography: 'h5', p: 2}}>Course Approvals</Box>
            </Stack>
            {showError && <Alert severity='error' sx={{mb: 2}}>
                You are submitting approval for a course that has an active change request.
            </Alert>}
            <Typography variant='body2'>
                Your are submitting resource approval for the following courses. Upon submission, you will
                no longer be able to submit resource change requests. Do you with to continue?
            </Typography>
        </Stack>}
    />
};

export default TableSelectedCourseApprovals;
